import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  MoreOutlined,
} from "@ant-design/icons";
import { Dropdown, Space, Table, Tag, Switch } from "antd";
import TableAntd from "components/elements/Table/Table";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const BranchList = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
  onView = () => { },
  onEdit = () => { },
  onStatus = () => { },
  onDelete = () => { },
  onChange = () => { },
}) => {
  const { t, i18n } = useTranslation();
  const roles = useSelector((state) => state.company.roles);

  const columns = [
    {
      title: <div className="text-table">{t("branch.label.branch_id")}</div>,
      dataIndex: "branchCode",
      key: "branchCode",
      align: "center",
      sorter: {
        compare: (a, b) => null,
      },
    },
    {
      title: <div className="text-table">{t("branch.label.name_en")}</div>,
      dataIndex: "branchNameEn",
      key: "branchNameEn",
      sorter: {
        compare: (a, b) => null,
      },
    },
    {
      title: <div className="text-table">{t("branch.label.name_th")}</div>,
      dataIndex: "branchName",
      key: "branchName",
      sorter: {
        compare: (a, b) => null,
      },
    },
    {
      title: <div className="text-table">{t("address.province")}</div>,
      dataIndex: "province",
      key: "province",
      sorter: {
        compare: (a, b) => null,
      },
      render: (_, record) => {
        const { province = {} } = record;
        const name =
          i18n.language === "en"
            ? province?.provinceNameEn
            : province?.provinceName;
        return (
          <>
            {name}
          </>
        );
      },
    },
    {
      title: <div className="text-table">{t("status.entity")}</div>,
      dataIndex: "statusFlag",
      key: "statusFlag",
      align: "center",
      render: (text, record) => (
        <Switch
          checked={text === "ACTIVE"}
          onChange={(checked) => onStatus(checked, record)}
        />
      ),
    },
    {
      title: <div className="text-table">{t("action.action")}</div>,
      key: "action",
      width: 64,
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: [
                {
                  key: "1",
                  onClick: () => onView(record),
                  label: `${t("action.view")}`,
                  icon: (
                    <EyeOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
                roles.includes("UPDATE_CONFIGURATION|COMPANY_SETTING|BRANCH") && (
                  {
                    key: "2",
                    onClick: () => onEdit(record),
                    label: `${t("action.edit")}`,
                    icon: (
                      <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
                    ),
                  }),
                roles.includes("DELETE_CONFIGURATION|COMPANY_SETTING|BRANCH") && (
                  {
                    key: "3",
                    onClick: () => onDelete(record),
                    label: `${t("action.delete")}`,
                    icon: (<DeleteOutlined style={{ fontSize: "18px", color: "gray" }} />
                    ),
                  }),
              ],
            }}
          >
            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
          </Dropdown>
        </Space>
      ),
    },
  ];

  return (
    <TableAntd
      loading={isLoading}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
      dataSource={dataSource}
      rowKey={(record) => record.id}
      columns={columns}
      onChange={onChange}
      scroll={{ x: true }}
    />
  );
};

export default BranchList;
